import React, { useState, useEffect, useContext } from 'react';
import { Apirequests } from '../../utils/ApiRequests';
import { AuthContext } from '../../contexts/AuthContext';
import { Trash } from 'lucide-react';

const Replies = ({ replies, deleteReply, ApproveReply, commentId }) => {
    const [loading, setLoading] = useState(false);
    const { user } = useContext(AuthContext);
    const [approveLoading, setApproveLoading] = useState({state:false,replyId:""});

    // console.log(replies,'repl')

    const approveReply = async (replyId) => {
        setApproveLoading({state:true,replyId});
        await ApproveReply(commentId, replyId);
        setApproveLoading({state:false,replyId:""});
    };

    const handleDelete = async (replyId) => {
        await deleteReply(commentId, replyId);
    };

    return (
        <div className="p-6 max-w-7xl mx-auto bg-white rounded-lg">
            <h2 className="text-2xl font-semibold text-center text-purple-700 mb-6">
                Replies
            </h2>
            <table className="min-w-full table-auto">
                <thead>
                    <tr className="bg-purple-600 text-white">
                        <th className="px-4 py-2 text-left">Actions</th>
                        <th className="px-4 py-2 text-left">User</th>
                        <th className="px-4 py-2 text-left">Content</th>
                        <th className="px-4 py-2 text-left">Status</th>
                        <th className="px-4 py-2 text-left">Date</th>
                    </tr>
                </thead>
                <tbody>
                    {replies?.map((reply) => (
                        <tr key={reply._id} className="border-b hover:bg-gray-100">
                            <td className="px-4 py-2">
                                <Trash
                                    onClick={() => handleDelete(reply._id)}
                                    className='cursor-pointer text-red-500' />
                            </td>
                            <td className="px-4 py-2">
                                <strong>{reply.userId.name}</strong>
                                <br />
                                <span className="text-sm text-gray-600">{reply.userId.email}</span>
                            </td>
                            <td className="px-4 py-2">{reply.content}</td>
                            <td className="px-4 py-2">

                                {reply.status !== "Approved" ? (
                                    <button className='p-1 rounded-xl border cursor-pointer border-indigo-400'
                                        onClick={() => approveReply(reply?._id)}
                                    >{approveLoading?.state && approveLoading?.replyId === reply?._id ? "Approving..." : "Approve"}</button>
                                ) : (
                                    reply.status
                                )}
                            </td>
                            <td className="px-4 py-2">{new Date(reply.createdAt).toLocaleString()}</td>
                            <td className="px-4 py-2 text-center text-indigo-600 cursor-pointer"
                            // onClick={() => setViewReplies({ state: true, replies: reply.replies })}
                            >
                                {/* {comment.replies.length} */}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Replies;